export class EditUserModel {
  id: number;
  newPassword?: string;
  confirmPassword?: string;
  isAdmin?: boolean;
  isAnalytics: boolean;
  email: string;
  firstName: string;
  lastName: string;
  role: number;
  venueId: any;
}

export class AddUserModel {
  firstName: string;
  lastName: string;
  email: string;
  newPassword: string;
  confirmPassword: string;
  isAnalytics: boolean;
  role: number;
  venueId: any;
  isAdmin?: boolean;
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/user-management/user-details/user-details.model.ts